import { __ } from '@wordpress/i18n';
import { useBlockProps, InnerBlocks, InspectorControls } from '@wordpress/block-editor';
import{Panel, PanelBody, PanelRow, TextControl, FormToggle} from "@wordpress/components"
import { useEffect} from "@wordpress/element";

export default function Edit(props){
    const { attributes, setAttributes, clientId} = props;
    const { blockId, pageLoad, timeToLoad, classRelated } = attributes;
   
    return(
        <>    
            <InspectorControls>
                <Panel>
                    <PanelBody title={__('Popup options')} className="modal-options">
                        <TextControl 
                            className='add-time'
                            label={__("Tiempo de espera")}
                            value= {timeToLoad}
                            type="number"
                            onChange={(newTimeToLoad)=> setAttributes({
                                timeToLoad: newTimeToLoad,
                            })}
                            min={1}
                        />
                        <TextControl 
                            className='add-custom-class'
                            label={__("Agregar para trigger")}
                            value= {classRelated}
                            help={__('ejecutara el modal segun la clase especificada')}
                            onChange={(NewClassRelated)=> setAttributes({
                                classRelated: NewClassRelated,
                            })}
                        />
                        <span >Nota: para mejor funcionamiento del popup anclarlo con su clase respectiva y agregarlos al final de todos los bloques</span>
                    </PanelBody>
                </Panel>
            </InspectorControls>
            <div {...useBlockProps} className = {`class-id-${clientId} content-modal`} >
                <span className='modals-text'>Contenido de modal</span>
                <InnerBlocks/>
            </div>
            
        </>
    )
}

